import { createSelector } from 'reselect';
import {
    transformSegments,
    transformPhotos,
    transformPartners,
} from './transformer.js';
import { transformTags } from '../Dashboard/transformers/';
import { dateStringToStartEndDateObj } from '../../common/utils.js';

export const getSegmentsState = (state) => state.segments.segments || [];

export const activeSegmentIdState = (state) =>
    state.segments.activeSegmentId || null;

export const getActiveSegmentId = createSelector(
    activeSegmentIdState,
    (segmentId) => segmentId,
);

export const getUserSegments = createSelector(getSegmentsState, (segments) => {
    return transformSegments(segments);
});

export const getDateState = (state) => state.segments.date || '';

export const getLandtypeState = (state) => state.segments.landType || '';

export const getSubLandtypeState = (state) => state.segments.subLandType || '';

export const getDate = createSelector(getDateState, (date) =>
    dateStringToStartEndDateObj(date),
);

export const getLandtype = createSelector(
    getLandtypeState,
    (landType) => landType,
);

export const getSubLandtype = createSelector(
    getSubLandtypeState,
    (subLandType) => subLandType,
);

export const getHasMoreSegmentsState = (state) =>
    state.segments.hasMoreSegments;

export const getHasMoreSegments = createSelector(
    getHasMoreSegmentsState,
    (hasMoreSegments) => hasMoreSegments,
);

export const getCurrentPageState = (state) => state.segments.currentPage || 0;

export const getCurrentPage = createSelector(
    getCurrentPageState,
    (currentPage) => 20 * currentPage,
);

export const getSegmentsLoadingState = (state) =>
    state.segments.segmentsLoading;

export const getSegmentsLoading = createSelector(
    getSegmentsLoadingState,
    (loading) => loading,
);
export const getMoreSegmentsLoadingState = (state) =>
    state.segments.moreSegmentsLoading;

export const getMoreSegmentsLoading = createSelector(
    getMoreSegmentsLoadingState,
    (loading) => loading,
);

export const getSegmentTagsState = (state) => state.segments.segmentTags || {};

export const getSegmentTags = createSelector(
    getSegmentTagsState,
    activeSegmentIdState,
    (tags, segmentId) => {
        const selectedTags = tags[segmentId]
            ? tags[segmentId].userTags
            : tags[segmentId];
        return transformTags(selectedTags, 'blue');
    },
);

export const getSegmentMLTags = createSelector(
    getSegmentTagsState,
    activeSegmentIdState,
    (tags, segmentId) => {
        const selectedTags = tags[segmentId]
            ? tags[segmentId].mlTags
            : tags[segmentId];
        return transformTags(selectedTags, 'orange');
    },
);

export const getSegmentTagsLoadingState = (state) =>
    state.segments.segmentsTagsLoading || false;

export const getSegmentTagsLoading = createSelector(
    getSegmentTagsLoadingState,
    (loading) => loading,
);

export const getSegmentPhotosLoadingState = (state) =>
    state.segments.segmentsPhotosLoading || false;

export const getSegmentPhotosState = (state) =>
    state.segments.segmentPhotos || {};

export const getSegmentPhotos = createSelector(
    getSegmentPhotosState,
    activeSegmentIdState,
    (photos, segmentId) => {
        return photos[segmentId] ? transformPhotos(photos[segmentId]) : null;
    },
);

export const getSegmentPhotosLoading = createSelector(
    getSegmentPhotosLoadingState,
    (loading) => loading,
);

export const getSegmentNotesLoading = (state) =>
    state.segments.savingNotes || false;

export const getSegmentDeleteLoading = (state) =>
    state.segments.deletingSegment || false;

export const getPartners = (state) =>
    transformPartners(state.segments.partners || []);

export const getSelectedPartners = (state) =>
    state.segments.selectedPartners || [];

export const getPartnersLoading = (state) =>
    state.segments.loadingPartners || false;
